import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import '../training-app/src/i18n'
import TrainingApp from '../training-app/src/App'
import TrainingLogin from '../training-app/src/Login'

const ComplianceApp = lazy(() => import('./App'))

const LoadingScreen = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#0f1f3d', color: '#fff' }}>
    <div>Loading...</div>
  </div>
)

export default function AppRouter() {
  return (
    <Router>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          {/* Training app routes */}
          <Route path="/training/login" element={<TrainingLogin />} />
          <Route path="/training" element={<TrainingApp />} />
          <Route path="/training/*" element={<TrainingApp />} />

          {/* NexusGuard routes (placeholder) */}
          {/* TODO: Add NexusGuard routes similarly */}

          {/* Compliance app - catches everything else */}
          <Route path="*" element={<ComplianceApp />} />
        </Routes>
      </Suspense>
    </Router>
  )
}
